/**
 * 🔥 HOT DEAL Badge Component
 * Displays deal heat level with animations
 */

import React from 'react';

const HotDealBadge = ({ deal, size = 'normal', showFactors = false }) => {
  if (!deal?.isHot) return null;

  const { badge, factors, hotScore, urgencyText } = deal;

  const sizeClasses = {
    small: 'text-xs px-2 py-1',
    normal: 'text-sm px-3 py-1.5',
    large: 'text-base px-4 py-2'
  };

  return (
    <div className="relative">
      {/* Main Badge */}
      <div className={`
        inline-flex items-center gap-1.5 font-black rounded-full
        bg-gradient-to-r ${badge.color}
        text-white shadow-lg shadow-red-500/30
        ${sizeClasses[size]}
        ${badge.animation || ''}
        transform hover:scale-105 transition-all duration-300
        cursor-default
      `}>
        <span className="animate-pulse">🔥</span>
        <span>{badge.label}</span>
        {hotScore && (
          <span className="ml-1 text-xs opacity-90">({hotScore}p)</span>
        )}
      </div>

      {/* Factors Tooltip */}
      {showFactors && factors && factors.length > 0 && (
        <div className="absolute top-full left-0 mt-2 z-50">
          <div className="bg-black/95 backdrop-blur-xl border border-red-500/30 rounded-xl p-3 shadow-2xl min-w-[200px]">
            <div className="text-xs text-gray-400 mb-2 uppercase tracking-wider">
              Miért HOT?
            </div>
            <ul className="space-y-1">
              {factors.slice(0, 4).map((factor, idx) => (
                <li key={idx} className="text-sm text-white flex items-center gap-2">
                  <span className="text-red-400">•</span>
                  {factor}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/* Urgency Text */}
      {urgencyText && size === 'large' && (
        <div className="mt-2 text-xs text-red-400 font-semibold animate-pulse">
          ⚠️ {urgencyText}
        </div>
      )}
    </div>
  );
};

export default HotDealBadge;
